import React from "react";
import { Redirect } from "react-router-dom";
import { Grid } from "semantic-ui-react";
import styled from "styled-components";
import { Constants, Paths } from "../Constants";
import dateTimeHelper from "../util/dateTimeHelper";
import BaseComponent from "./BaseComponent";
import AppHeaderSmall from "./common/AppHeaderSmall";
import Footer from "./common/Footer";
import MainContentWrapper from "./common/MainContentWrapper";
import PillButton from "./common/PillButton";
import SFCookieConsent from "./common/SFCookieConsent";
import SFLoader from "./common/SFLoader";
import SiteWrapper from "./common/SiteWrapper";
import TabBar from "./common/TabBar";
import TestCard from "./common/TestCard";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const ButtonGroup = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: row;
`;

class Following extends BaseComponent {
  constructor() {
    super();
    this.state = {
      consumer: null,
      showConfirmCancel: false,
      showLoader: false,
    };
    this.validStrongDate = this.validStrongDate.bind(this);
    this.validWeakDate = this.validWeakDate.bind(this);
    this.windowDate = this.windowDate.bind(this);
    this.deleteSubscription = this.deleteSubscription.bind(this);
  }

  async componentDidMount() {
    this.setState({ consumer: this.props.location.state.publisher });
  }

  validStrongDate() {
    return (
      this.state.consumer.strongSafetyDate != null &&
      new Date(this.state.consumer.strongSafetyDate) > new Date()
    );
  }

  validWeakDate() {
    return (
      this.state.consumer.weakSafetyDate != null &&
      new Date(this.state.consumer.weakSafetyDate) > new Date()
    );
  }

  windowDate(dateValue) {
    const date = new Date(dateValue);
    return (
      dateTimeHelper.getDayOfWeek(date) +
      ", " +
      (date.getMonth() + 1) +
      "/" +
      date.getDate() +
      ", " +
      (date.getHours() > 12 ? date.getHours() - 12 : date.getHours()) +
      ":" +
      date.getMinutes() +
      (date.getHours() > 12 ? "pm" : "am")
    );
  }

  async deleteSubscription() {
    if (!(await this.checkLogin())) {
      return;
    }

    this.setState({ showLoader: true });
    const response = await this.safeFunApi.deleteSubscription(
      this.state.consumer.sF_ConsumerSubscriptionId
    );
    this.setState({ showLoader: false });
    if (!response.data.success) {
      this.errorManager.addError("Failed to cancel the pending follow request");
      this.forceUpdate();
      return;
    }
    this.redirect(Paths.PEOPLE);
  }

  render() {
    return (
      <SiteWrapper>
        {this.state.redirectPath ? (
          <Redirect
            to={{
              pathname: this.state.redirectPath,
              search: this.state.redirectSearch,
              state: this.state.redirectState,
            }}
          />
        ) : null}

        <AppHeaderSmall title="Following" />
        <SFLoader active={this.state.showLoader} />
        <MainContentWrapper>
          <TabBar people />

          <Wrapper>
            <Grid columns={1} style={{ width: "400px", margin: "0" }}>
              <Grid.Row>
                <Grid.Column style={{ margin: "0", padding: "0" }}>
                  {this.state.consumer ? (
                    <TestCard
                      currentUser={false}
                      consumer={this.state.consumer}
                    />
                  ) : null}
                </Grid.Column>
              </Grid.Row>

              <ButtonGroup>
                {this.state.showConfirmCancel ? (
                  <>
                    <PillButton
                      style={{ width: "150px" }}
                      primary
                      onClick={() => {
                        this.deleteSubscription();
                      }}
                    >
                      Confirm
                    </PillButton>
                    <PillButton
                      style={{
                        width: "150px",
                        backgroundColor: "white",
                        borderColor: "#1cbff2",
                        borderWidth: 2,
                        borderStyle: "solid",
                      }}
                      onClick={() => {
                        this.setState({ showConfirmCancel: false });
                      }}
                    >
                      Cancel
                    </PillButton>
                  </>
                ) : (
                  <PillButton
                    style={{ width: "150px" }}
                    primary
                    onClick={() => {
                      this.setState({ showConfirmCancel: true });
                    }}
                  >
                    Unfollow
                  </PillButton>
                )}
              </ButtonGroup>

              <Grid.Row>
                <Grid.Column style={{ textAlign: "center" }}>
                  <a
                    href={Constants.TESTING_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Click to learn more about our testing
                    <br /> philosophy and SafeWindows
                  </a>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Wrapper>
        </MainContentWrapper>
        <Footer />
        <SFCookieConsent />
      </SiteWrapper>
    );
  }
}

export default Following;
